//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getProjectStatus} from '@/assets/js/dict';
export default {
    created(){
        getProjectStatus().then(res=>{
            this.statusList=res
        })
    },
    data: () => ({
        statusList:[],
        list:[],
        loading:false,
        finished:false,
        form:{
           title:'',
           serviceType:'',
           pageIndex:1,
           pageSize:10,
           projectStatus:3 //3进行中 1已完成 4已取消
        },
        userId:'',
        userType:''
    }),
    methods: {
       // 项目列表
        getList(page){
            if(page){
                this.list=[]
                this.form.pageIndex=page
            }
            this.loading=true;
            this.$get('/tra/project/processList',this.form,function(res){
               if(res.code==200){
                    var newArr = res.data.records;
                    if (!newArr || newArr.length === 0) {
                        this.finished = true
                    } else {
                        this.list.push(...newArr)
                        this.form.pageIndex = this.form.pageIndex + 1
                    }
                    this.loading = false
               }
            })
        },
        // 点击搜索
        search(){
            this.getList(1)
        },
        // 跳转详情
        detail(item){
            var userId = getSession('user').id
            var userType = getSession('user').currentUserType
            if(userType==2){ //发包商
                if(item.createBy==userId){
                    if(item.serviceType==2&&item.assessType!=3){ //召开评估会
                        this.$router.push({
                            path:'/outsourcer/underProMeetInfo?id='+item.id
                        })
                    }else{
                        this.$router.push({
                            path:'/outsourcer/underProInfo?id='+item.id
                        })
                    }
                }else{
                    this.$message.info('当前身份没有参与该项目,不可进入')
                }
            }else{ //服务商
                if(item.createBy!=userId){
                    if(item.serviceType==2&&item.assessType!=3){ //召开评估会
                        this.$router.push({
                            path:'/facilitator/underProMeetInfo?id='+item.id
                        })
                    }else{
                        this.$router.push({
                            path:'/facilitator/underProInfo?id='+item.id
                        })
                    }
                }else{
                    this.$message.info('当前身份没有参与该项目,不可进入')
                }
               
            }
        }
    },
    mounted() {
       this.userId= getSession('user').id
       this.userType = getSession('user').currentUserType
    }
}
